var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStumped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.379 181.762C265.222 194.585 261.011 202.865 251.93 210.685C244.352 217.211 227.312 211.257 219.005 206.448C156.312 170.162 262.712 102.206 272.805 188.119",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.065 56.2674C233.4 49.0105 211.16 49.8486 210.668 67.9246C209.981 93.048 253.423 100.346 250.895 82.347C248.671 66.5302 207.737 64.8803 206.392 86.1018C204.373 117.921 245.672 115.368 240.012 109.614C210.668 101.735 205.716 122.49 229.129 133.916",
    stroke: "#000000",
    strokeOpacity: 0.5,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.515 187.1C158.292 192.174 145.431 195.236 133.549 204.858C17.0839 299.14 172.706 226.239 185.933 246.075C197.323 263.164 172.922 328.092 167.172 348.215",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.783 189.638C197.666 235.086 233.78 218.16 278.927 218.16",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6448 169.649C38.1192 203.514 54.7914 234.844 64.8542 267.547",
    stroke: "#000000",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2775 267.547C96.4004 262.153 126.561 268.77 154.151 263.254",
    stroke: "#000000",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.741 275.904C105.209 299.672 102.75 323.348 106.278 346.947",
    stroke: "#000000",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1241 340.654C78.3324 312.44 133.908 316.53 142.127 346.665",
    stroke: "#000000",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M213.123 341.872C212.054 310.584 211.586 279.123 214.864 247.994",
    stroke: "#000000",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M347.147 242.92C346.008 271.37 347.94 334.103 349.34 341.873",
    stroke: "#000000",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192.544 225.159C248.406 225.159 315.523 225.159 370.152 225.159",
    stroke: "#000000",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M326.768 93.2217C320.676 118.594 308.375 156.843 301.865 189.401",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M317.093 145.087C323.556 168.408 330.646 191.403 338.503 213.971",
    stroke: "#000000",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M318.955 220.487C326.688 219.225 332.886 219.551 341.295 219.733",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStumped);
export default __webpack_public_path__ + "static/media/stumped.c6a577b33d06bd0b5568a39b0e40d258.svg";
export { ForwardRef as ReactComponent };